import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import { BoardItemProgramList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import SlideBox from './slideBox';
import { Link } from 'react-router-dom';

export default function MostPopular() {
  const { mode } = useSelector((state) => state);

  const boardCustomType = useContent('boardCustomType');
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const boardId = boardCustomType ? boardCustomType.csv.find((v) => v.type === '5').id : 3;

  const { isSuccess, data } = useQuery(
    ['main', 'most-popular'],
    async () => {
      const programList = await BoardItemProgramList({
        lan_code: mode,
        board_id: boardId,
        title: '',
        content_category: '',
        event_category: null,
        is_open_allow: true,
        is_blind_allow: false,
        hit: true,
        page_info: { row_count: -1, number: 0 },
      });

      return programList.data.items.map((item) => ({
        programId: item.program_id,
        image: item.image.find((img) => img.type === 'square').url,
        title: item.program_title,
        link: `/${item.type}/${item.program_id}`,
      }));
    },
    {
      enabled: !!mode && !!boardId,
      retry: false,
      staleTime: 1000 * 60 * 3,
    }
  );

  if (!isSuccess) return null;
  return (
    <div>
      <div className="title-box">
        <h2>
          Most <em>Popular</em>
        </h2>
        <p>ASC, I hope we meet again</p>
      </div>
      {data.map((program) => (
        <div className="content-box" key={program.programId}>
          <Link to={program.link} title={anchorTitle}>
            <img
              src={program.image}
              width={215}
              height={215}
              alt=""
              className="program-image"
              onError={(e) => (e.target.src = require('@/assets/images/common/174_174_A.png').default)}
            />
          </Link>
          <SlideBox mode={mode} programId={program.programId} anchorTitle={anchorTitle} />
        </div>
      ))}
    </div>
  );
}
